import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2, RotateCw, X } from "lucide-react";

// Il tesserino di cantiere in sovrimpressione, per quando la persona non ce
// l'ha addosso e arriva un controllo. E' esattamente la stessa immagine che
// si stampa sul badge di plastica e che esce nel PDF da ritagliare: il
// disegno lo fa il server (etichette.py), qui si mostra e basta. Prima lo
// schermo aveva una sua impaginazione somigliante, e si vedeva una tessera
// diversa da quella in tasca. Si ruota per riempire il telefono in
// verticale, si chiude toccando fuori.
export default function TesserinoSchermo({ employeeId, onChiudi }) {
  const [immagine, setImmagine] = useState(null);
  const [errore, setErrore] = useState(null);
  const [ruotato, setRuotato] = useState(false);

  useEffect(() => {
    let vivo = true;
    let indirizzo = null;
    api.get(`/employees/${employeeId}/tesserino-immagine`, { responseType: "blob" })
      .then(({ data }) => {
        if (!vivo) return;
        indirizzo = URL.createObjectURL(data);
        setImmagine(indirizzo);
      })
      .catch(async (e) => {
        if (!vivo) return;
        // Con responseType blob anche il messaggio d'errore arriva come file:
        // va riletto, altrimenti si vedrebbe «[object Blob]».
        let detta = "Tesserino non disponibile";
        try {
          const testo = await e.response?.data?.text?.();
          detta = JSON.parse(testo)?.detail || detta;
        } catch { /* resta il messaggio generico */ }
        setErrore(detta);
      });
    return () => {
      vivo = false;
      if (indirizzo) URL.revokeObjectURL(indirizzo);
    };
  }, [employeeId]);

  // Larghezza della tessera: quasi tutto lo schermo; ruotata, quasi tutta
  // l'altezza. Le proporzioni sono quelle del disegno, 85 x 50 mm.
  const larghezza = ruotato ? "min(92vh, 640px)" : "min(94vw, 640px)";

  return (
    <div className="fixed inset-0 z-[70] bg-slate-950/95 flex flex-col items-center justify-center p-4"
         onClick={onChiudi} data-testid="tesserino-schermo">
      <div className="absolute top-3 right-3 flex gap-2" onClick={(e) => e.stopPropagation()}>
        <button type="button" onClick={() => setRuotato((r) => !r)} title="Ruota"
                className="w-10 h-10 rounded-full bg-white/10 text-white flex items-center justify-center">
          <RotateCw className="w-5 h-5" />
        </button>
        <button type="button" onClick={onChiudi} title="Chiudi"
                className="w-10 h-10 rounded-full bg-white/10 text-white flex items-center justify-center">
          <X className="w-5 h-5" />
        </button>
      </div>

      {!immagine && !errore && <Loader2 className="w-8 h-8 animate-spin text-white/60" />}
      {errore && <p className="text-white text-sm text-center max-w-sm">{errore}</p>}

      {immagine && (
        <div onClick={(e) => e.stopPropagation()}
             style={{ width: larghezza, transform: ruotato ? "rotate(90deg)" : "none",
                      transition: "transform .3s" }}>
          <img src={immagine} alt="Tesserino di riconoscimento"
               className="w-full rounded-lg shadow-2xl bg-white" />
        </div>
      )}
      <p className="text-white/50 text-xs mt-4">Tocca fuori dalla tessera per chiudere</p>
    </div>
  );
}
